import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";
import { IDistrict, IProvince, IWard } from "./administrative.interface";

const PROVINCE_CODE_HA_NOI = "01";
const PROVINCE_CODE_HO_CHI_MINH = "79";

class AdministrativeService {
  getAllProvince() {
    return httpService.get<IProvince[]>(`${apiService.utils.administrative.getAllProvince}`);
  }

  /** Hanoi, then Ho Chi Minh City, then the rest A-Z - the order the apps present provinces in. */
  async getAllProvinceSorted() {
    const response = await this.getAllProvince();
    const pinned = [PROVINCE_CODE_HA_NOI, PROVINCE_CODE_HO_CHI_MINH];

    const sorted = [...(response.data ?? [])].sort((a, b) => {
      const rankA = pinned.indexOf(String(a.code));
      const rankB = pinned.indexOf(String(b.code));

      if (rankA !== rankB) {
        return (rankA < 0 ? pinned.length : rankA) - (rankB < 0 ? pinned.length : rankB);
      }

      return String(a.name ?? "").localeCompare(String(b.name ?? ""), "vi");
    });

    return { ...response, data: sorted };
  }

  /**
   * @deprecated The endpoint returns 404: the 2025 administrative merge removed the district level.
   * Use `getListWardByProvinceCode`. Kept only because `IProvince.districts` still types it.
   */
  getListDistrictByProvinceCode(province_code?: string) {
    return httpService.get<IDistrict[]>(`${apiService.utils.administrative.getAllDistrictByProvinceCode}`, { params: { province_code } });
  }

  // Since the 2025 administrative merge a province holds wards directly - there is no district
  // level in between any more, and `all-provinces` returns each province with an empty `districts`.
  getListWardByProvinceCode(province_code?: string) {
    return httpService.get<IWard[]>(`${apiService.utils.administrative.getAllWardByProvinceCode}`, { params: { province_code } });
  }
}

export default new AdministrativeService();
